import PropTypes from 'prop-types'
import { useSidebarState } from 'react-admin'
// material
import { styled } from '@mui/material/styles'
import { Box, Drawer } from '@mui/material'
// hooks
import useResponsive from '../../hooks/useResponsive'

// components
import Scrollbar from '../Scrollbar'
import SideNav from './SideNav'
import LogoFrame from '../icons/LogoFrame'

const DRAWER_WIDTH = 280

const SideBarWrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}))

const SideBar: React.FC = () => {
  const isDesktop = useResponsive('up', 'lg', 0, 0)
  const paperProps = isDesktop
    ? {
        borderRightStyle: 'dashed',
      }
    : {}
  const [open, setOpen] = useSidebarState()

  const sideBarContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <LogoFrame
          sx={{
            // width: 40,
            height: 40,
          }}
        />
      </Box>
      <SideNav />
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  )

  return (
    <SideBarWrapper>
      <Drawer
        open={isDesktop || open}
        onClose={isDesktop ? (): void => undefined : (): void => setOpen(false)}
        variant={isDesktop ? 'persistent' : 'temporary'}
        PaperProps={{
          sx: {
            width: DRAWER_WIDTH,
            ...paperProps,
          },
        }}
      >
        {sideBarContent}
      </Drawer>
    </SideBarWrapper>
  )
}

SideBar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
}

export default SideBar
